// extracted by mini-css-extract-plugin
export default {"thePageContentContainer":"ThePageContent_thePageContentContainer__gJgcu"};